module.exports = __webpack_public_path__ + "static/media/aws_solution_architect_logo.763914d2.png";